import React from 'react';
import NumberFormat from 'react-number-format';
const style = { fontSize: '18px', fontWeight: 'bold' };

const Total = ({ data, params }) => {
    const offset = params.length - Object.keys(data).length;
    let td = getValues(params.slice(offset), data);

    return (
        <tr>
            <td colSpan={offset} style={style}>Total</td>
            {td}
        </tr>
    );
};

function getValues(params, row) {
    return params.map(param => {
        const value = row[param];

        if(Array.isArray(value)) {
            const compareValue = getCompareValue(value[1], value[2]);

            return(<td key={param}>
                <NumberFormat value={value[0]} displayType={"text"} thousandSeparator={true}/>
                <br/>
                {compareValue}
            </td>);
        }

        return(<td key={param}>
            <NumberFormat value={value} displayType={"text"} thousandSeparator={true}/>
        </td>);
    });
}

function getCompareValue(absoluteValue, percentValue) {
    let color;
    const prefix = absoluteValue > 0 ? '+' : '';

    if(absoluteValue > 0) color = 'green';
    if(absoluteValue < 0) color = 'red';
    if(absoluteValue == 0) color = 'grey';

    absoluteValue = <NumberFormat value={absoluteValue} prefix={prefix} displayType={"text"} thousandSeparator={true}/>
    percentValue = <NumberFormat value={percentValue} prefix={prefix} suffix={'%'} displayType={"text"} thousandSeparator={true}/>

    return <span style={{ color }}>{absoluteValue} {percentValue}</span>;
}


export default Total;



// WEBPACK FOOTER //
// ./src/components/StatsTable/components/Table/components/TotalRow/index.js